const templateWizardFormDefaults = {
  blockStyles: {
    all: 'inherit',
    fluidContainer: true,
    'padding-top': 0,
    'padding-left': 0,
    'padding-right': 0,
    'padding-bottom': 0,
    'margin-top': 0,
    'margin-left': 0,
    'margin-right': 0,
    'margin-bottom': 0,
    'background-color': 'transparent',
    position: 'relative',
    width: 1140,
  },
  titleStyles: {
    'font-size': 24,
    'padding-top': 4,
    'padding-left': 0,
    'padding-right': 0,
    'padding-bottom': 4,
    'margin-top': 4,
    'margin-left': 0,
    'margin-right': 0,
    'margin-bottom': 4,
    'text-align': 'center',
    'font-style': 'normal',
    'font-weight': 'bold',
    'text-decoration': 'none',
    'text-transform': 'none',
    color: '#000',
    'background-color': 'transparent',
  },
  topCallToActionStyles: {
    content: '',
    'font-size': 24,
    'padding-top': 4,
    'padding-left': 0,
    'padding-right': 0,
    'padding-bottom': 4,
    'margin-top': 4,
    'margin-left': 0,
    'margin-right': 0,
    'margin-bottom': 4,
    'text-align': 'center',
    'font-style': 'normal',
    'font-weight': 'bold',
    'text-decoration': 'none',
    'text-transform': 'none',
    color: '#000',
    'background-color': 'transparent',
  },
  bottomCallToActionStyles: {
    content: '',
    'font-size': 24,
    'padding-top': 4,
    'padding-left': 0,
    'padding-right': 0,
    'padding-bottom': 4,
    'margin-top': 4,
    'margin-left': 0,
    'margin-right': 0,
    'margin-bottom': 4,
    'text-align': 'center',
    'font-style': 'normal',
    'font-weight': 'bold',
    'text-decoration': 'none',
    'text-transform': 'none',
    color: '#000',
    'background-color': 'transparent',
  },
  productNameStyles: {
    'font-size': 15,
    'padding-top': 4,
    'padding-left': 0,
    'padding-right': 0,
    'padding-bottom': 4,
    'margin-top': 4,
    'margin-left': 0,
    'margin-right': 0,
    'margin-bottom': 4,
    'text-align': 'center',
    'font-style': 'normal',
    'font-weight': 'normal',
    'text-decoration': 'none',
    'text-transform': 'none',
    color: '#000',
    display: 'inline-block',
    width: '100%',
  },
  discountBadgeStyles: {
    'padding-top': 4,
    'padding-left': 10,
    'padding-right': 10,
    'padding-bottom': 4,
    'font-size': 14,
    'background-color': '#FF0000',
    'font-weight': 'bold',
    'font-style': 'normal',
    'border-radius': '8',
    width: 'max-content',
    display: 'block',
    top: 10,
    left: '',
    right: 10,
    bottom: '',
    color: '#fff',
    position: 'absolute',
  },
  productPriceStyles: {
    'font-size': 14,
    'padding-top': 0,
    'padding-left': 0,
    'padding-right': 0,
    'padding-bottom': 0,
    'margin-top': 0,
    'margin-left': 0,
    'margin-right': 0,
    'margin-bottom': 0,
    'font-style': 'normal',
    'font-weight': 'normal',
    'text-decoration': 'none',
    color: '#000',
    width: 'auto',
    display: 'inline-block',
  },
  productDiscountPriceStyles: {
    'font-size': 18,
    'padding-top': 0,
    'padding-left': 0,
    'padding-right': 0,
    'padding-bottom': 0,
    'margin-top': 0,
    'margin-left': 10,
    'margin-right': 0,
    'margin-bottom': 0,
    'font-style': 'normal',
    'font-weight': 'bold',
    'text-decoration': 'none',
    color: '#FF0000',
    width: 'auto',
    display: 'inline-block',
  },
  productPriceDiscountedStyles: {
    'font-size': 14,
    'padding-top': 0,
    'padding-left': 0,
    'padding-right': 0,
    'padding-bottom': 0,
    'margin-top': 0,
    'margin-left': 10,
    'margin-right': 0,
    'margin-bottom': 0,
    'font-style': 'normal',
    'font-weight': 'normal',
    'text-decoration': 'line-through',
    color: '#000',
    width: 'auto',
    display: 'inline-block',
  },
  arrowsStyles: {
    top: 175,
    left: 0,
    right: 0,
    position: 'absolute',
    width: 56,
    height: 56,
    'background-color': '#ccc',
    border: '0',
    'border-radius': '0',
    fill: 'transparent',
    stroke: '#000',
    'z-index': 10,
    'padding-top': 0,
    'padding-left': 0,
    'padding-right': 0,
    'padding-bottom': 0,
    centered: true,
  },
  generalFontStyles: {
    'font-family': 'Arial',
  },
};

export default templateWizardFormDefaults;
